// extracted by mini-css-extract-plugin
export default {"list":"RestaurantList_list__D-MIa","empty":"RestaurantList_empty__g3bnK","emptyIcon":"RestaurantList_emptyIcon__RtJ8D","divider":"RestaurantList_divider__IsSYC"};